module.exports = __webpack_public_path__ + "img/banner afbeelding exchange course catalogue.8d62303f.jpg";